import React, { Component } from 'react';
import { toast } from 'react-toastify';

import FormError from 'components/FormError';

class ToggleLockedPlan extends Component {
  state = {
    loading: false,
  };

  handleTogglePlan = () => {
    const { sub, lockPlan } = this.props;

    this.setState({ loading: true });
    const newLock = !sub.plan_locked;
    lockPlan(sub.id, newLock)
      .then(() => {
        this.setState({ loading: false });
        toast.success(`Plan ${newLock ? 'Locked' : 'Unlocked'}`);
      })
      .catch((e) => {
        if (e.errors) {
          let transformedError = e.errors;
          const keys = Object.keys(transformedError);
          keys.forEach((key) => {
            if (Array.isArray(transformedError[key])) {
              transformedError[key] = transformedError[key].join('; ');
            }
          });
          toast.error(<FormError error={transformedError} />);
        } else {
          toast.error(<FormError error={e} />);
        }
        this.setState({ loading: false });
      });
  };

  render() {
    const { sub } = this.props;
    const { loading } = this.state;

    if (!sub || (sub && !sub.plan)) {
      return null;
    }

    return (
      <button
        className="btn btn-default mar-l"
        disabled={loading}
        onClick={this.handleTogglePlan}
      >
        {sub.plan_locked ? 'Unlock Plan' : 'Lock Plan'}
      </button>
    );
  }
}

export default ToggleLockedPlan;
